// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskInstructionsVideoPlayer-styles-module--container--5LBsW"};